"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Card_1 = require("@material-ui/core/Card");
const CardHeader_1 = require("@material-ui/core/CardHeader");
const Checkbox_1 = require("@material-ui/core/Checkbox");
const FormControlLabel_1 = require("@material-ui/core/FormControlLabel");
const FormGroup_1 = require("@material-ui/core/FormGroup");
const Grid_1 = require("@material-ui/core/Grid");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const _ = require("lodash");
const React = require("react");
const CardBody_1 = require("../card/CardBody");
const assets_1 = require("../config/assets");
const SurveyScreenStyle_1 = require("./jss/SurveyScreenStyle");
const SurveyImage_1 = require("./SurveyImage");
class MultiSelectQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.toggleValue = (option) => {
            const { question, onChange } = this.props;
            let { value } = this.state;
            if (this.isSelected(option)) {
                value = value.filter(x => x.id !== option.id);
            }
            else {
                value.push(option);
            }
            this.setState({ value });
            onChange(question, value);
        };
        this.isSelected = (option) => {
            const { value } = this.state;
            return value.filter(x => x.id === option.id).length > 0;
        };
        this.getOptions = () => {
            const { question } = this.props;
            const questionOptions = question.options ? question.options : question.answer_options;
            return ((0, jsx_runtime_1.jsx)(FormGroup_1.default, { children: questionOptions.map((option, index) => this.renderOptions(index, option)) }));
        };
        this.renderOptions = (index, option) => {
            const { question, questionIndex, classes, imageSurveyLayout, quizPostSuccess, isQuizStyleAplied, quizRetryResponse, isQuizRetry } = this.props;
            const imageClass = imageSurveyLayout !== 'list' ? classes.optionImage : classes.optionImageLarge;
            let quizResponseObj;
            if (quizRetryResponse && (quizRetryResponse === null || quizRetryResponse === void 0 ? void 0 : quizRetryResponse.length) > 0) {
                quizResponseObj = quizRetryResponse.find(q => q.question_id.toString() === question.id.toString());
            }
            else {
                quizResponseObj = !!quizPostSuccess
                    ? quizPostSuccess.quiz_response.find(q => q.question_id.toString() === question.id.toString())
                    : undefined;
            }
            const isSelectedOptionCorrect = this.isQuizAnswerCorrect(quizResponseObj);
            const isOptionCorrect = !!quizResponseObj &&
                !!quizResponseObj.correct_answers &&
                quizResponseObj.correct_answers.includes(_.toNumber(option.id));
            const isSelected = this.isSelected(option);
            let showGreeenBorder = isSelectedOptionCorrect && isOptionCorrect;
            if (!isQuizRetry) {
                showGreeenBorder = isOptionCorrect;
            }
            const showRedBorder = isSelected && !isQuizRetry && !!quizResponseObj;
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: isQuizStyleAplied
                    ? {
                        border: '3px solid',
                        padding: '5px 10px 0px 15px',
                        marginBottom: '8px',
                        borderColor: showGreeenBorder
                            ? '#5cb860'
                            : showRedBorder
                                ? '#f55a4e'
                                : this.props.theme.palette.grey[500]
                    }
                    : {} }, { children: [(0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: this.isSelected(option), onChange: this.toggleValue.bind(this, option), value: option.value, color: "primary" }, option.id), label: _.unescape(option.value) }), option.image_url && ((0, jsx_runtime_1.jsx)(SurveyImage_1.default, { imageUrl: option.image_url, imageTitle: option.value, imageClass: imageClass }))] }), index));
        };
        this.isQuizAnswerCorrect = (quizResponseObj) => {
            var _a, _b;
            const compareFunction = (a, b) => {
                if (a < b)
                    return -1;
                if (a > b)
                    return 1;
                return 0;
            };
            const sortSelectedAnswers = (_a = quizResponseObj === null || quizResponseObj === void 0 ? void 0 : quizResponseObj.selected_answers) === null || _a === void 0 ? void 0 : _a.sort(compareFunction);
            const sortCorrectAnswers = (_b = quizResponseObj === null || quizResponseObj === void 0 ? void 0 : quizResponseObj.correct_answers) === null || _b === void 0 ? void 0 : _b.sort(compareFunction);
            return quizResponseObj
                ? JSON.stringify(sortSelectedAnswers) === JSON.stringify(sortCorrectAnswers)
                : undefined;
        };
        this.state = {
            value: []
        };
    }
    componentDidMount() {
        const { surveyOptions } = this.props;
        this.setState({ value: surveyOptions });
    }
    render() {
        const { question, theme, quizPostSuccess, quizRetryResponse } = this.props;
        let quizResponseObj;
        if (quizRetryResponse && (quizRetryResponse === null || quizRetryResponse === void 0 ? void 0 : quizRetryResponse.length) > 0) {
            quizResponseObj = quizRetryResponse.find(q => q.question_id.toString() === question.id.toString());
        }
        else {
            quizResponseObj = !!quizPostSuccess
                ? quizPostSuccess.quiz_response.find(q => q.question_id.toString() === question.id.toString())
                : undefined;
        }
        const isAnsweredCorrect = this.isQuizAnswerCorrect(quizResponseObj);
        return ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ xs: 12, item: true, style: { paddingBottom: theme.spacing(2) } }, { children: (0, jsx_runtime_1.jsxs)(Card_1.default, Object.assign({ style: { width: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(CardHeader_1.default, { title: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", component: 'span', style: {
                                color: theme.palette.text.primary,
                                paddingTop: theme.spacing(4),
                                paddingBottom: theme.spacing(4),
                                textAlign: 'start'
                            } }, { children: question.value })), style: {
                            backgroundColor: theme.palette.grey.A200
                        } }), (0, jsx_runtime_1.jsxs)(CardBody_1.default, { children: [!!quizResponseObj && ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ style: { marginBottom: theme.spacing(1) } }, { children: (0, jsx_runtime_1.jsx)("img", { src: isAnsweredCorrect
                                        ? assets_1.assets.internalAssets.correctIcon
                                        : assets_1.assets.internalAssets.incorrectIcon }) }))), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, style: { paddingBottom: theme.spacing(2) } }, { children: this.getOptions() }))] })] })) })));
    }
}
exports.default = (0, styles_1.withTheme)((0, styles_1.withStyles)(SurveyScreenStyle_1.default)(MultiSelectQuestion));
//# sourceMappingURL=MultiSelectQuestion.js.map